export const PPC_TYPE_TO_ESM_VIEW_NAME = {
  StandaloneButton: "Standalone_Button",
  "2 Column 50-50": "X2_Column_50_50",
  "2 Column Image Left 50-50": "X2_Column_Image_Left_50_50",
  "2 Column Image Right 50-50": "X2_Column_Image_Right_50_50",
  "2 Column Image Left 33-66": "X2_Column_Image_Left_33_66",
  "2 Column Image Right 33-66": "X2_Column_Image_Right_33_66",
  "3 Column 33-33-33": "X3_Column_33_33_33",
  "Headline only": "Headline_only",
  "Image Only": "Image_Only",
  "Text Only Full Page": "Text_Only_Full_Page",
  "Microsoft Project Page": "Microsoft_Project_Page",
  "Splash Page": "Splash_Page",
};

export const mapProjectPageComponentToProps = (projectPageComponent) => {
  console.log(
    "projectPageComponent",
    projectPageComponent?.RecordType?.Name,
    PPC_TYPE_TO_ESM_VIEW_NAME[projectPageComponent?.RecordType?.Name || ""],
  );

  return {
    type: PPC_TYPE_TO_ESM_VIEW_NAME[
      projectPageComponent?.RecordType?.Name || ""
    ],
    headline_1: projectPageComponent?.Headline_1__c || "",
    headline_2: projectPageComponent?.Headline_2__c || "",
    headline_3: projectPageComponent?.Headline_3__c || "",
    text_area_1: projectPageComponent?.Text_Area_1__c || "",
    text_area_2: projectPageComponent?.Text_Area_2__c || "",
    text_area_3: projectPageComponent?.Text_Area_3__c || "",
    button_type_1: projectPageComponent?.Button_Type__c || "",
    button_type_2: projectPageComponent?.Button_Type_2__c || "",
    button_type_3: projectPageComponent?.Button_Type_3__c || "",
    button_name_1: projectPageComponent?.Button_Name_1__c || "",
    button_name_2: projectPageComponent?.Button_Name_2__c || "",
    button_name_3: projectPageComponent?.Button_Name_3__c || "",
    button_url_1:
      projectPageComponent?.Button_URL_1__c ||
      projectPageComponent?.File_Download_URL_1__c ||
      "",
    button_url_2:
      projectPageComponent?.Button_URL_2__c ||
      projectPageComponent?.File_Download_URL_2__c ||
      "",
    button_url_3:
      projectPageComponent?.Button_URL_3__c ||
      projectPageComponent?.File_Download_URL_3__c ||
      "",
    image_location_1: projectPageComponent?.Image_Location_1__c || "",
    image_location_2: projectPageComponent?.Image_Location_2__c || "",
    image_location_3: projectPageComponent?.Image_Location_3__c || "",
  };
};
